// @ts-nocheck
import { useCallback, useEffect, useState } from 'react';
import { getVoteRoomWaiverReadiness } from '../../../../../../services/AnalysisApiClient';

const defaultReadiness = { required: false, ready: true, items: [] };
const blockedReadiness = { required: true, ready: false, items: [] };

export function useWaiverLaunchReadiness(analysisId: string | null | undefined) {
  const [readiness, setReadiness] = useState(defaultReadiness);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!analysisId) {
      setReadiness(defaultReadiness);
      setError(null);
      return defaultReadiness;
    }
    setLoading(true);
    setError(null);
    try {
      const data = (await getVoteRoomWaiverReadiness(analysisId)) ?? defaultReadiness;
      setReadiness(data);
      return data;
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Failed to load waiver status.';
      setError(message);
      setReadiness(blockedReadiness);
      return blockedReadiness;
    } finally {
      setLoading(false);
    }
  }, [analysisId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    readiness,
    waiverReady: !error && (!readiness.required || readiness.ready),
    loading,
    error,
    refresh,
  };
}
